import { Input } from "#components/ui/input"
import { Label } from "#components/ui/label"
import { ReactNode } from "react"
import { Control, Controller, FieldError } from "react-hook-form"

interface FormFieldProps {
  name: string
  control: Control<any>
  label: string
  type?: string
  placeholder?: string
  error?: FieldError
  id?: string
  labelAction?: ReactNode
}

export function FormField({
  name,
  control,
  label,
  type = "text",
  placeholder,
  error,
  id,
  labelAction,
}: FormFieldProps) {
  const fieldId = id || name

  return (
    <div className="grid gap-3">
      <div className={labelAction ? "flex items-center" : undefined}>
        <Label htmlFor={fieldId}>{label}</Label>
        {labelAction}
      </div>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Input
            id={fieldId}
            type={type}
            placeholder={placeholder}
            {...field}
            className={error ? "border-red-500" : ""}
          />
        )}
      />
      {error && <p className="text-sm text-red-500">{error.message}</p>}
    </div>
  )
}
